export default __webpack_public_path__ + "images/DX.8d1a74f.png";